import baseIsEqual from "./component-library338.mjs";
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
export {
  isEqual as default
};
